import { initializeApp } from "firebase/app";

import { getMessaging } from "firebase/messaging";

//Firebase Config values imported from .env file
const firebaseConfig = {
  apiKey: "AIzaSyD0NuS8-QCgM1RL8YDAYZg5Eg7an35oh5Q",
  authDomain: "spor-5887e.firebaseapp.com",
  projectId: "spor-5887e",
  storageBucket: "spor-5887e.firebasestorage.app",
  messagingSenderId: "572670962203",
  appId: "1:572670962203:web:f64cef076a70dbb1fd26be",
  measurementId: "G-J6FJ3NQCB8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
export const messaging = getMessaging(app);